export default __webpack_public_path__ + "static/media/Pamungkas - One Only (Lyrics Video).2865ee9c.mp3";